import "./Login2.css";
import { useState } from "react";
import { useFormik } from "formik";
import { useNavigate, Link } from "react-router-dom";
import { Mail, Lock, Eye, EyeOff, LogIn } from "lucide-react";

import { login } from "../../services/Authservice";
import { storage } from "../../utils/storage";
import { Snackbar } from "../../utils/snackbar";
import { validateLogin } from "../../utils/validators/loginValidator";

const Login = () => {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error",
  });

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      rememberMe: false,
    },
    validate: validateLogin,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const res = await login(values);
        console.log(res.data.token);
        storage.set("ntk", res.data.token);
        storage.set("admin", res.data);
        navigate("/dashboard");

        // if (admin) {
        //   storage.set({
        //     token,
        //     role: "admin",
        //     user: admin,
        //     rememberMe: values.rememberMe,
        //   });
        //   navigate("/dashboard");
        //   return;
        // }

        // if (volunteer) {
        //   storage.set({
        //     token,
        //     role: "volunteer",
        //     user: volunteer,
        //     rememberMe: values.rememberMe,
        //   });
        //   navigate("/verify-causes");
        //   return;
        // }
      } catch (err) {
        showSnackbar(
          err.response?.data?.msg || "Unable to login. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <div className="login-page">
        <div className="bg-pattern"></div>
        <div className="bg-circle circle-1"></div>
        <div className="bg-circle circle-2"></div>
        <div className="bg-circle circle-3"></div>
        <div className="login-overlay" />

        <div className="login-form-panel">
          <div className="form-header">
            <h2>Sign In</h2>
            <p>Enter your credentials to access your account</p>
          </div>

          <form className="login-form" onSubmit={formik.handleSubmit}>
            <div className="form-group">
              <label>
                <Mail size={16} />
                Email Address
              </label>
              <div className="input-wrapper">
                <input
                  type="email"
                  name="email"
                  placeholder="admin@example.com"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </div>
              {formik.touched.email && formik.errors.email && (
                <div className="validation_error">{formik.errors.email}</div>
              )}
            </div>

            <div className="form-group">
              <label>
                <Lock size={16} />
                Password
              </label>
              <div className="input-wrapper">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter your password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
              {formik.touched.password && formik.errors.password && (
                <div className="validation_error">{formik.errors.password}</div>
              )}
            </div>

            <div className="form-options">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formik.values.rememberMe}
                  onChange={formik.handleChange}
                />
                <span className="checkbox-custom"></span>
                Remember me
              </label>

              <Link to="/forgot-password" className="forgot-link">
                Forgot password?
              </Link>
            </div>

            <button
              type="submit"
              className={`login-btn ${loading ? "loading" : ""}`}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Signing in...
                </>
              ) : (
                <>
                  <LogIn size={18} />
                  Sign In
                </>
              )}
            </button>
          </form>

          <div className="login-footer">
            <p>© 2026 Zakat Admin. All rights reserved.</p>
          </div>
        </div>
      </div>

      <Snackbar
        open={snackbar.open}
        message={snackbar.message}
        severity={snackbar.severity}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      />
    </>
  );
};

export default Login;
